"use client";

import * as React from "react";
import { Line, LineChart } from "recharts";
import { ChartContainer } from "@/components/ui/chart";
const metricsData = [{
  id: "aum",
  label: "ACTIVE WORKING STRATEGIES",
  value: "1",
  data: [{
    value: 1.10
  }, {
    value: 1.12
  }, {
    value: 1.11
  }, {
    value: 1.15
  }, {
    value: 1.18
  }, {
    value: 1.21
  }, {
    value: 1.24
  }]
}, {
  id: "traders",
  label: "COMMUNITY MEMBERS",
  value: "35",
  data: [{
    value: 42000
  }, {
    value: 42500
  }, {
    value: 43100
  }, {
    value: 43800
  }, {
    value: 44200
  }, {
    value: 44900
  }, {
    value: 45231
  }]
}, {
  id: "winrate",
  label: "CUSTOMER SUPPORT",
  value: "24/7",
  data: [{
    value: 72.1
  }, {
    value: 73.5
  }, {
    value: 74.2
  }, {
    value: 75.8
  }, {
    value: 76.9
  }, {
    value: 77.5
  }, {
    value: 78.4
  }]
}];
export default function RealTimeEcosystemMetrics() {
  return <section id="real-time-ecosystem-metrics" className="dark bg-background text-foreground border-y border-border/40 py-8 lg:py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 justify-center lg:divide-x lg:divide-border/40 lg:gap-0">
          {metricsData.map((item, i) => <div key={item.id} data-index={i} className="flex flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
              <h3 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
                {item.label}
              </h3>
              <div className="mt-3 font-mono text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
                {item.value}
              </div>
              <div className="mt-4 h-10 w-full max-w-[120px] opacity-80 transition-opacity duration-300 hover:opacity-100">
                <ChartContainer config={{
              value: {
                color: "var(--color-primary)"
              }
            }} className="h-full w-full">
                  <LineChart data={item.data}>
                    <Line type="monotone" dataKey="value" stroke="var(--color-value)" strokeWidth={2.5} dot={false} isAnimationActive={true} animationDuration={1500} />
                  </LineChart>
                </ChartContainer>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}